import { closeBannerAction } from "../../../Actions/UIActions/GetAppBanner/CloseBannerAction";
import { getBannerSessionAction } from "../../../Actions/UIActions/GetAppBanner/GetBannerSessionAction";
import { getOROpenAppAction } from "../../../Actions/UIActions/GetAppBanner/GetOROpenAppAction";
import { getOSInfoAction } from "../../../Actions/UIActions/GetAppBanner/GetOSInfoAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { OSTypes } from "../../../Orchestrator/Types/Interface/IGetAppBanner";
import { BannerContext } from "../Context/BannerContext";

class BannerInitStep extends StepFlow {
  get stepName() {
    return "BannerInit_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<{ outsideClick: boolean }, void>({
        eventName: evtTree.GetAppBanner.Load.Session,
        handler: async () => {
          const context = this.getCtx<BannerContext>("bannerContext");
          if (context) {
            context.bannerVisible = true;
          }
          await getBannerSessionAction.execute();
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<{ outsideClick: boolean }, void>({
        eventName: evtTree.GetAppBanner.Load.OSInfo,
        handler: async () => {
          await getOSInfoAction.execute();
          const context = this.getCtx<BannerContext>("bannerContext");
          if (context && getOSInfoAction.result) {
            context.osInfo = getOSInfoAction.result;
          }
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.GetAppBanner.CrossIcon.Click,
        handler: () => {
          const context = this.getCtx<BannerContext>("bannerContext");
          if (context) {
            context.bannerVisible = false;
          }
          closeBannerAction.execute();
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<void, void>({
        eventName: evtTree.GetAppBanner.GetOROpenApp.Click,
        handler: async () => {
          const context = this.getCtx<BannerContext>("bannerContext");
          if (context) {
            context.osInfo;
            getOROpenAppAction.setParams({ osInfo: context.osInfo });
            getOROpenAppAction.execute();
          }
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("Banner Init Step Execute.............................");
    // Run the event to get the banner session
    _eventBus.emit({
      eventName: evtTree.GetAppBanner.Load.Session,
    });
    _eventBus.emit({
      eventName: evtTree.GetAppBanner.Load.OSInfo,
    });
    const bannerContext = new BannerContext();
    this.setCtx<BannerContext>("bannerContext", bannerContext);

    // sessionStorage.setItem("hideBanner", "true");
    /**
     * Below code is to handle auto open destination popup for location selection
     * From Origin step it's return a init step of search
     * Here in init we check origin is already selected then tear down the init step automatically
     * and it's start destination step.
     */
  }
}

export const BannerInitStepDeclaration = new StepDefinition({
  stepName: "BannerInit_Step",
  stepClass: BannerInitStep,
});
